// Internal
import { ChildCertificate } from "@/api/__types/attendance";
import StatusIndicator from "@/components/StatusIndicator";
import { DATE_FORMAT_US_SLASHES } from "@/utils/dates";
import { Tooltip } from "antd";

// MISC
import BigNumber from "bignumber.js";
import dayjs from "dayjs";

export const getActiveCertificatesColumns = () => [
  {
    dataIndex: "_",
    key: "_",
    width: 20,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render: (_: string, record: ChildCertificate) => {
      if (
        !record.expiringSoon &&
        !record.expiringSoonLow &&
        !record.expiringSoonCritical
      ) {
        return null;
      }

      const _statusType = record.expiringSoonCritical
        ? "critical"
        : record.expiringSoon
          ? "major"
          : "minor";

      return (
        <div className="ml-auto table">
          <Tooltip
            title={
              <span className="whitespace-pre-wrap">{record.notes}</span>
            }
            placement="left"
          >
            <div>
              <StatusIndicator type={_statusType} size={18} />
            </div>
          </Tooltip>
        </div>
      );
    },
  },
  {
    title: "Provider Name",
    dataIndex: "providerName",
    key: "providerName",
    width: 250,
    sorter: (a: ChildCertificate, b: ChildCertificate) =>
      a.providerName.localeCompare(b.providerName),
  },
  {
    title: "Provider ID",
    dataIndex: "providerId",
    key: "providerId",
    width: 160,
  },
  {
    title: "Certificate ID",
    dataIndex: "certificateId",
    key: "certificateId",
    width: 160,
  },
  {
    title: "Service Type",
    dataIndex: "serviceType",
    key: "serviceType",
    width: 220,
    sorter: (a: ChildCertificate, b: ChildCertificate) =>
      a.serviceType.localeCompare(b.serviceType),
  },
  {
    title: "Approved Fee Assistance Amount",
    dataIndex: "feeAssistanceRate",
    key: "feeAssistanceRate",
    render: (text: string) => `$${BigNumber(text).toFormat()}/month`,
    width: 180,
    sorter: (a: ChildCertificate, b: ChildCertificate) =>
      +a.feeAssistanceRate - +b.feeAssistanceRate,
  },
  {
    title: "Start Date",
    dataIndex: "dateCertBegins",
    key: "dateCertBegins",
    render: (text: string) => dayjs(text).format(DATE_FORMAT_US_SLASHES),
    width: 160,
    sorter: (a: ChildCertificate, b: ChildCertificate) =>
      +new Date(a?.dateCertBegins || "") - +new Date(b?.dateCertBegins || ""),
    defaultSortOrder: "ascend",
  },
  {
    title: "End Date",
    dataIndex: "dateCertEnds",
    key: "dateCertEnds",
    render: (text: string) => dayjs(text).format(DATE_FORMAT_US_SLASHES),
    width: 160,
    sorter: (a: ChildCertificate, b: ChildCertificate) =>
      +new Date(a?.dateCertEnds || "") - +new Date(b?.dateCertEnds || ""),
  },
];
